import { IconButton } from '@mui/material';
import {Print} from '@mui/icons-material';
import Loading from "components/Loading";
import { useMobileDetect, useTabletDetection } from "containers/chat/hooks";
import { get } from "lodash";
import React, { useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { useCurrentUser } from "store/users/selectors";
import "./bingoPrint.css";
import { makeRowColGrid } from "../helper";
import GridView from "../teacher/gridView";

// Utility to shuffle the grid
const shuffleGrid = (grid) => {
  return grid.map((row) => {
    const shuffledRow = [...row];
    for (let i = shuffledRow.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledRow[i], shuffledRow[j]] = [shuffledRow[j], shuffledRow[i]];
    }
    return shuffledRow;
  });
};

const PrintHeader = ({ title, subtitle }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "40px 40px 0 40px",
        width: "100%",
      }}
    >
      <p
        style={{
          margin: 0,
          fontSize: "18px",
          lineHeight: "30px",
          color: "black",
        }}
      >
        {title}
      </p>
      <p
        style={{
          margin: 0,
          fontSize: "18px",
          color: "black",
        }}
      >
        {subtitle}
      </p>
    </div>
  );
};

const PrintComponent = React.forwardRef(({ data, grid, selectedType, bingoSize }, ref) => {
  return (
    <div ref={ref} className="print-container-loteria printable">
      {data.map((student) => {
        const modifyGrid = makeRowColGrid(grid, bingoSize, selectedType);
        const shuffledGrid = shuffleGrid(modifyGrid);
        return (
          <table key={student.id} className="report-container">
            <thead>
              <tr>
                <td>
                  <PrintHeader
                    title="Loteria de One Way Education"
                    subtitle={`${student.firstName} ${student.lastName}`}
                  />
                </td>
              </tr>
            </thead>
            <tbody className="report-content-loteri">
              <tr>
                <td className="report-content-cell">
                  <div className="main">
                    <GridView grid={shuffledGrid} readOnly={true} selectedType={selectedType} />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        );
      })}
    </div>
  );
});

const PrintLoteria = ({
  data,
  grid,
  classUsers,
  isGridValid,
  selectedType,
  bingoSize = null,
  showSnack = () => {}
}) => {
  const currentUser = useCurrentUser();
  const componentRef = useRef();
  const [printloader, setPrintloader] = useState(false);
  const location = useLocation();
  							  const navigate = useNavigate();
  const isTablate = useTabletDetection();
  const isMobile = useMobileDetect() && !isTablate;

  const cellSelectedType = useMemo(() => {
    if ((selectedType === "OnlyImage") || (selectedType === "VocabImage")) {
      return "Image";
    } else if (selectedType === "VocabWord") {
      return "Word";
    }else{
      return selectedType;
    }
  }, [selectedType]);

  function isChromeOniOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isChrome = /CriOS/.test(userAgent);
    return isIOS && isChrome;
  }

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "Custom Print Document",
    onBeforeGetContent: async () => {
      setPrintloader(true);
    },
    onBeforePrint: async () => {
      setPrintloader(false);
    },
  });

  const redirectToNextPage = () => {
    navigate({
      pathname: "/print_assignment",
      state: data,
    });
  };
  const onPrint = () => {
    if (isMobile) {
      showSnack("Print is not supported on mobile!", "error");
      return;
    }
    if (isTablate) {
      showSnack("Print is not supported on tab!", "error");
      return;
    }
    if (classUsers.length === 0) {
      showSnack("No students available to print!", "error");
      return;
    }
    if (!isGridValid) {
      showSnack("Please complete the Lotería First!", "error");
      return;
    }
    if (isChromeOniOS()) {
      redirectToNextPage();
    } else {
      handlePrint();
    }
  };

  if (get(currentUser, "role") === "owe_admin") {
    return null;
  }

  return (
    <div className="w-fit-content">
      <IconButton
        style={{ padding: 0, color: "white" }}
        aria-label="print"
        onClick={onPrint}
      >
        {printloader ? (
          <Loading size={20} />
        ) : (
          <Print style={{ color: "black" }} />
        )}
      </IconButton>
      <div style={{ display: "none" }} className='printable'>
        <PrintComponent
          ref={componentRef}
          data={classUsers}
          grid={grid}
          selectedType={cellSelectedType}
          bingoSize={bingoSize}
        />
      </div>
    </div>
  );
};

export default PrintLoteria;
